<template>
  <div
    v-if="isToast"
    class="toast d-flex p-2"
    :class="[dynamicToastClass, isInline ? 'align-items-center' : 'align-items-start']">
    <div
      class="toast__icon d-flex align-items-center justify-content-center mr-1"
      :class="{ 'toast__icon--info': type == 'infor' }">
      <i class="icon" :class="dynamicIconClass"></i>
    </div>
    <div class="d-flex justify-content-between grow-1" :class="isInline ? 'align-items-center' : 'align-items-start'">
      <div
        class="d-flex justify-content-between toast__content grow-1"
        :class="isInline ? 'align-items-center' : !isInlineAction && 'flex-column'">
        <p
          class="toast__content-desc paragraph-14-regular text-light-high"
          :class="{ 'toast__content-desc--info': type == 'infor' }">
          <slot name="description"></slot>
        </p>
        <p
          v-if="actionTitle"
          class="toast__content-action paragraph-12-medium"
          :class="isInlineAction && 'toast__content-action-inline'"
          @click="triggerAction">
          {{ actionTitle }}
        </p>
        <a
          v-if="contentLinkTitle"
          class="toast__content-link paragraph-12-medium"
          :class="{ 'mt-1': !isInline, 'mr-2': isInline }"
          :href="contentLink"
          target="_blank"
          >{{ contentLinkTitle }}</a
        >
      </div>
      <div v-if="isClose" class="toast__close d-flex align-items-center justify-content-center" @click="close">
        <i class="icon icon-cancel text-light-high"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Toast',
  props: {
    type: String,
    content: String,
    contentLinkTitle: String,
    contentLink: String,
    isClose: Boolean,
    isCloseOnAction: Boolean,
    isInline: Boolean,
    isInlineAction: Boolean,
    actionTitle: String,
  },
  emits: ['onClose', 'action'],
  data() {
    return {
      isToast: true,
    };
  },
  computed: {
    dynamicToastClass() {
      switch (this.type) {
        case 'infor':
          return 'toast--info';
        default:
          return 'toast--warn';
      }
    },
    dynamicIconClass() {
      switch (this.type) {
        case 'warn':
          return 'icon-warn-triangle';
        default:
          return 'icon-infor-circle-fill';
      }
    },
  },
  methods: {
    triggerAction() {
      if (this.isCloseOnAction) this.isToast = false;
      this.$emit('action');
    },
    close() {
      this.$emit('onClose');
      this.isToast = false;
    },
  },
};
</script>

<style lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';

.grow-1 {
  flex-grow: 1 !important;
}

.toast {
  width: 100%;
  border-radius: 3px;
  min-height: 56px;

  &__icon {
    width: 20px;
    height: 20px;
    font-size: 17.5px;
    color: $black3;

    &--info {
      width: 24px;
      height: 24px;
      font-size: 21px;
    }

    .icon-infor-circle-fill {
      color: $mono5;
    }
  }

  &--warn {
    background-color: $accent-amber200;
  }

  &--info {
    background-color: $blue3;
  }

  &__content {
    &-link,
    &-action {
      cursor: pointer;
      color: $mono4;
      position: relative;
      width: fit-content;
      height: 24px;
      padding: 0 8px;
      @include flex-center;
      &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 24px;
        border-radius: 3px;
        background-color: #000000;
        opacity: 0;
        @include trans-all;
      }
      &:hover::before {
        opacity: 0.1;
      }
      &-inline {
        flex: none;
        line-height: 24px !important;
        margin-left: 16px !important;
      }
    }
    &-desc {
      &--info {
        line-height: 24px;
      }
    }
  }

  &__close {
    width: 16px;
    height: 22px;
    font-size: 18px;
    cursor: pointer;
  }
}
</style>
